import { gradient } from './config';
import { $post, $api } from '@/service/request';

export default {
	state: () => ({
		lotteryList: [], // 转盘列表
		adInfo: null, // 广告信息
		// 抽奖信息
		drawInfo: {
			can: 0, //今日累计可使用次数
			now_can: 0, //当前可使用次数
			done: 0, //今日已使用此时
			daily_limit: 3, //每日转盘限制
		},
		pendantList: [], // 头像挂件列表
		avatar: '',
		// 用户当前装扮的挂件
		isFirst: false, // 是否是第一次玩
		pendantUse: false,
	}),
	mutations: {
		setLotteryList(state, payload) {
			state.lotteryList = payload;
		},
		setAdInfo(state, payload) {
			state.adInfo = payload;
		},
		setDrawInfo(state, payload) {
			state.drawInfo = payload;
		},

		setPendantList(state, payload) {
			state.pendantList = payload;
		},
		setAvatar(state, payload) {
			state.avatar = payload;
		},

		setIsFirst(state, payload) {
			state.isFirst = payload;
		},
		setPendantUse(state, payload) {
			state.pendantUse = payload;
		},
	},
	actions: {
		async getTurntableInfo({ commit }) {
			const { data, code } = await $post($api.INIT_TURNTABLE_API, { id: 3 });
			if (+code === 0) {
				const { config, video_model, can, now_can, done, daily_limit, newUse, pendant_use } = data;
				const drawInfo = { can, now_can, done, daily_limit };
				commit('setLotteryList', config);
				commit('setAdInfo', video_model);
				commit('setDrawInfo', drawInfo);
				commit('setIsFirst', newUse);
				commit('setPendantUse', pendant_use);
			}
		},

		async getPendantList({ commit }) {
			const { data, code } = await $post($api.GET_TURNTABLE_PENDANT_API);
			if (+code === 0) {
				const { pendants, avatar } = data;
				commit('setPendantList', pendants);
				commit('setAvatar', avatar);
			}
		},
	},
	getters: {
		// 转盘信息列表，加入渐变
		lotteryList(state) {
			let list = [...state.lotteryList];
			list = list.map((item, index) => {
				if (index % 2 === 0) {
					return { ...item, gradient };
				} else {
					return item;
				}
			});
			return list;
		},

		// 广告信息
		adInfo(state) {
			return state.adInfo;
		},

		// 抽奖信息
		drawInfo(state) {
			return state.drawInfo;
		},

		// 挂件列表
		pendantList(state) {
			return state.pendantList;
		},

		// 用户头像
		avatar(state) {
			return state.avatar;
		},

		// isFirst
		isFirst(state) {
			return state.isFirst;
		},

		// pendantUse
		pendantUse(state) {
			return state.pendantUse;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/draw-pendant.js